module.exports = __webpack_public_path__ + "static/media/familyties.c7051802.png";